(function ($) {
     $(document).ready(function () {
          console.log('core loaded');
          const header = 'o-header';
          const nav = 'o-nav';
          const flyout = 'o-form-search';
          // mobile menu
          $(`.${nav}--mobile-menu-icon`).click(function () {
               $(this).toggleClass('open');
               $(`.${header}__mobile-menu`).slideToggle();
          });

          // mobile submenu dropdowns
          $('.menu-item-has-children button').click(function () {
               $(this).parent('.menu-item').toggleClass('open');
          });

          // find part modal/form-search
          $('.find-part-modal a').on('click', function (e) {
               e.preventDefault();
               $(`.${flyout}--flyout`).addClass('open-flyout');
          });

          $(`.${flyout}__close`).on('click', function () {
               $(`.${flyout}--flyout`).removeClass('open-flyout');
          });
     });
})(jQuery);
